/**
 * Generación de CSV (item 7): convierte tablas a texto CSV compatible con Excel. Puro y testeable.
 * Escapa comillas/comas/saltos de línea según RFC 4180 y antepone un BOM para que Excel lea bien
 * los acentos (UTF-8). Separador coma (Excel en es-CL también lo abre).
 */

/** Escapa una celda: la envuelve en comillas si contiene coma, comilla o salto de línea. */
export function escapeCsvCell(value: string): string {
  const v = value ?? "";
  if (/[",\n\r]/.test(v)) return `"${v.replace(/"/g, '""')}"`;
  return v;
}

/** Construye el contenido CSV (con BOM) a partir de encabezados y filas de celdas string. */
export function toCsv(headers: readonly string[], rows: readonly (readonly string[])[]): string {
  const line = (cells: readonly string[]): string => cells.map(escapeCsvCell).join(",");
  const body = [line(headers), ...rows.map(line)].join("\r\n");
  return `﻿${body}`;
}

/** Nombre de archivo sugerido: <base>-YYYY-MM-DD.csv (sin caracteres problemáticos). */
export function suggestCsvName(base: string): string {
  const clean = (base || "informe").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  const date = new Date().toISOString().slice(0, 10);
  return `${clean || "informe"}-${date}.csv`;
}
